import angular from 'angular';

import {
  contains,
  getNameFromFullname,
  hideMiddleName,
  isEmpty,
  upperFirstChar,
} from './functions';
import { megaNumber } from './megaNumber';
import { tel } from './tel';

export default angular
  .module('est.filters', [])
  .filter('megaNumber', [() => megaNumber])
  .filter('tel', [() => tel])
  .filter('sanitize', [
    '$sce',
    function ($sce: angular.ISCEService) {
      return function (htmlCode: string) {
        return $sce.trustAsHtml(htmlCode);
      };
    },
  ])
  .filter('upperFirstChar', [() => upperFirstChar])
  .filter('getNameFromFullname', [() => getNameFromFullname])
  .filter('hideMiddleName', [() => hideMiddleName])
  .filter('contains', [() => contains])
  .filter('encodeURIComponent', () => window.encodeURIComponent)
  .filter('isEmpty', [() => isEmpty]);
